export const CONFIG = {
    client_name : "cosmo",
    client_display_name : "Cosmo",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : ` https://esr.fe-bis.de/de/cosmo/`,
    plz_validation : (plz : string) => plz.length == 5,
    foerderung : true,
    plz_default: "12345",
    development_mode: false,
}